export default __webpack_public_path__ + "static/winter-8bf20501499c0277c873f950dafa733c.webp";